export const CATEGORY_NAME_ADD = 'CATEGORY_NAME_ADD';
export const CATEGORY_NAME_REMOVE= 'CATEGORY_NAME_REMOVE';
export const SET_CATEGORY_PRODUCTS= 'SET_CATEGORY_PRODUCTS';
